import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsSoftwareProformaFormsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-proforma-project-forms',
	path: '/jira/software/c/projects/:projectKey/settings/forms',
	exact: true,
};
